import type { II18nPackageRes } from '@/interface/ICommon';
import * as React from 'react';
import { ReoSubscribe as ReoSubscribe } from '@reolink-deps/reolink_web.fe.shared-modules';
import { ReoSubscribe as CamovueSubscribe } from '@camovue-deps/reolink_web.fe.shared-modules';
import handleUbbTextWithV2 from '@/utils/shared/handleUbbTextWithV2';
import classNames from 'classnames';
import styles from './index.module.less';
import './index.less';

export interface IProps {
    subject: string;
    country: string;
    commingText: string | undefined;
    className?: string;
    commingTextClassName?: string;
    onSuccess?: (email?: string) => void;
    inputClassName?: string;
    inputWidth?: string|number;
    btnText?: string;
    btnClassName?: string;
    checkboxWrapClassName?: string;
    privacyNotAgreeErrorMsg?: string;
    isRepeatAsSuccess?: boolean;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const Subscribe: React.FC<IProps & II18nPackageRes> = (props) => {

    const handelSuccess = React.useCallback((email?: string) => {
        props.onSuccess?.(email);
    }, [props]);

    const subscribeDom = React.useMemo(() => {
        if (__MERCHANT__ === 'camovue') {
            return (
                <CamovueSubscribe
                    subject={ props.subject }
                    langPack={ props.i18nPackage }
                    inputIconName='icon-icon_email-facet'
                    iconClassName={ styles.icon }
                    inputClassName={ classNames(styles.reo_input, styles.subscribe_input, props.inputClassName) }
                    checkboxWrapClassName={ classNames(styles.reo_subscription_checkbox, props.checkboxWrapClassName) }
                    iconColor='#fff'
                    disabledIconColor='#fff'
                    inputWidth={ props.inputWidth }
                    country={ props.country }
                    wrapClassName={ classNames(styles.reo_subscribe_wrap, 'subscribe-wrap') }
                    successClassName={ 'success_wrap' }
                    onSuccess={ handelSuccess }
                    submitBtnText={ props.btnText }
                    submitBtnClassName={ props.btnClassName }
                    privacyNotAgreeError={ props.privacyNotAgreeErrorMsg }
                />
            );
        }
        return (
            <ReoSubscribe
                subject={ props.subject }
                langPack={ props.i18nPackage }
                inputIconName='icon-icon_email-facet'
                iconClassName={ styles.icon }
                inputClassName={ classNames(styles.reo_input, styles.subscribe_input, props.inputClassName) }
                checkboxWrapClassName={ classNames(styles.reo_subscription_checkbox, props.checkboxWrapClassName) }
                iconColor='#fff'
                disabledIconColor='#fff'
                inputWidth={ props.inputWidth }
                country={ props.country }
                wrapClassName={ classNames(styles.reo_subscribe_wrap, 'subscribe-wrap') }
                successClassName={ 'success_wrap' }
                onSuccess={ handelSuccess }
                submitBtnText={ props.btnText }
                submitBtnClassName={ props.btnClassName }
                privacyNotAgreeError={ props.privacyNotAgreeErrorMsg }
                isRepeatAsSuccess={ props.isRepeatAsSuccess }
            />
        );
    }, [handelSuccess,
        props.btnClassName, props.btnText, props.checkboxWrapClassName,
        props.country, props.i18nPackage, props.inputClassName,
        props.inputWidth, props.subject,
        props.privacyNotAgreeErrorMsg, props.isRepeatAsSuccess
    ]);

    return (
        <div className={ props.className }>
            {
                props.commingText ?
                    (
                        <p
                            className={ classNames(styles.come_soon, props.commingTextClassName) }
                            dangerouslySetInnerHTML={
                                { __html: handleUbbTextWithV2(props.commingText, { mode: 'inline' }) }
                            }
                        >
                        </p>
                    ) : ''
            }
            {subscribeDom}
        </div>
    );
};

export { Subscribe };
